import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "digital-product-notification"
    }}>{`Digital Product Notification`}</h1>
    <p>{`A digital product notification is a short notice or message that a consumer receives upon the update of a digital product. This helps the customer be sure about what updates are made to a specific product. Registered customers who have purchased a digital item receive the notifications. Therefore, registered customers who have purchased a digital item must be logged in to receive the notification.`}</p>
    <h2 {...{
      "id": "enable-send-email-to-purchased-customer-of-any-digital-product-when-that-digital-product-get-update"
    }}>{`Enable "Send email to purchased customer of any digital product, when that digital product get update."`}</h2>
    <p>{`To recieve a digital product notification the admin must need to  enable "Send email to purchased customer of any digital product, when that digital product get update." from the `}<inlineCode parentName="p">{`Shop Settings`}</inlineCode>{` module. `}</p>
    <p><img alt="digitalProductNotification" src={require("../../images/digitalNotification2.png")} /></p>
    <h2 {...{
      "id": "create-digital-product-notification"
    }}>{`Create Digital Product Notification.`}</h2>
    <p>{`A product can be set to a digital form by enabling `}<inlineCode parentName="p">{`is Digital`}</inlineCode>{` option from the `}<inlineCode parentName="p">{`Add Product`}</inlineCode>{` form. By uploading a digital file on the "Upload Image" section users are able to set a digital product. `}</p>
    <p><img alt="digitalProductNotification" src={require("../../images/digitalNotification3.png")} /></p>
    <p>{`To send a digital product notification, the user needs to update the digital product. The user needs to re-upload the digital file and enable "Send email to already purchased customer of this item about this update." option. You can send message towards customer about the update and then click on "Update Product" button. `}</p>
    <p><img alt="digitalProductNotification" src={require("../../images/digitalNotification4.png")} /></p>
    <h2 {...{
      "id": "digital-product-mail-for-customers"
    }}>{`Digital Product Mail for Customers.`}</h2>
    <p>{`The registered customers will be able to received a mail for new update is available.`}</p>
    <p><img alt="digitalProductNotification" src={require("../../images/digitalNotification5.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      